<template>
  <div>
    <Pos_debt_balance_list/>
  </div>
</template>

<script>
import Pos_debt_balance_list from "@/components/adminArin/pos_system/product/Pos_debt_balance_list";
export default {
  name: "PosDebtBalanceList",
  components: {
    Pos_debt_balance_list
  }
}
</script>

<style scoped>

</style>
